<template>
  <div class="text-center">
    <v-dialog v-model="localDialog" persistent width="620">
      <v-form ref="form" v-model="valid">
        <v-card style="border-radius: 20px">
          <v-card-title>
            <v-row class="pt-16" no-gutters>
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="10" md="10" xs="10" sm="10">
                <span style="font-size: 32px; font-weight: 500; color: #353535">
                  {{ $t("managepage.rooms") }}</span
                >
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row no-gutters>
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="12" md="4" xs="4" sm="4" class="mt-2">
                <span style="font-size: 18px; font-weight: 500; color: #353535">
                  {{ $t("roomsetting.roomname") }} :
                </span>
              </v-col>
              <v-col cols="12" md="7" xs="7" sm="7">
                <v-text-field
                  autofocus
                  outlined
                  v-model="nameroom"
                  :rules="roomnamerules"
                  dense
                  style="font-size: 12px"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="12" md="4" xs="4" sm="4" class="mt-2">
                <span style="font-size: 18px; font-weight: 500; color: #353535">
                  {{ $t("roomsetting.linkmeeting") }} :
                </span>
              </v-col>
              <v-col cols="9" md="5" xs="5" sm="5">
                <v-textarea
                  outlined
                  dense
                  rows="3"
                  no-resize
                  v-model="txtLink"
                  style="font-size: 12px"
                  readonly
                  disabled
                ></v-textarea>
              </v-col>
              <v-col cols="1" md="1" xs="1" sm="1" class="pl-7">
                <v-btn outlined block @click="copylink" color="#0B3A8F">
                  <v-icon dark> mdi-content-copy </v-icon></v-btn
                >
              </v-col>
              <input type="hidden" v-model="txtLink" id="txtLink" ref="txtLink" />
            </v-row>
            <v-row no-gutters class="mt-n7">
              <v-col cols="0" md="5" xs="5" sm="5"></v-col>
              <v-col cols="12" md="7" xs="7" sm="7">
                <span style="font-size: 14px; color: #cccccc">
                  *{{ $t("roomsetting.detaimeeting") }}
                </span>
              </v-col>
            </v-row>
            <v-row class="pb-2">
              <v-col cols="1" md="1" sm="1" sx="1"></v-col>
              <v-col cols="12" md="10" sm="10" sx="10" class="mt-n4 mb-n4">
                <v-btn
                  text
                  class="no-uppercase p-0 m-0"
                  style="color: #3d85c6; font-size: 20px; text-decoration: underline"
                  @click="clickToShowOptions"
                  >{{ $t("roomsetting.setting") }}</v-btn
                >
                <v-icon style="color: #3d85c6" @click="clickToShowOptions">
                  mdi-chevron-down
                </v-icon>
              </v-col>
            </v-row>
            <div v-if="showOptions">
              <v-form ref="form">
                <v-row no-gutters class="mt-4" v-if="false">
                  <v-col cols="1" md="1" xs="1" sm="1"></v-col>
                  <v-col cols="12" md="4" xs="4" sm="4" class="mt-2">
                    <span style="font-size: 18px; font-weight: 500; color: #353535">
                      เว็บไคลเอ็นต์:
                    </span>
                  </v-col>
                  <v-col cols="12" md="7" xs="7" sm="7">
                    <v-text-field outlined dense disabled v-model="type"></v-text-field>
                    <!-- <v-select
                  :items="web"
                  label="OneRTC (recommend)"
                  outlined
                  v-model="type"
                  dense
                  ></v-select> -->
                  </v-col>
                </v-row>
                <v-form ref="form">
                  <v-row no-gutters class="mb-n2">
                    <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                    <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                      <span style="font-size: 18px; font-weight: 500; color: #353535">{{
                        $t("roomsetting.passwordrooms")
                      }}</span>
                    </v-col>
                    <v-col cols="12" md="7" sm="7" xs="7">
                      <!-- :rules="[filterInput]" -->
                      <!-- @keypress="passwordkey" -->
                      <v-text-field
                        :rules="[filterInput]"
                        outlined
                        clearable
                        dense
                        v-model="key"
                        @keypress="userpassword"
                        append-icon="mdi-dice-multiple"
                        @click:append="clickToAddPassword"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row no-gutters class="mb-n2" v-if="false">
                  <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                  <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                    <span style="font-size: 18px; font-weight: 500; color: #353535"
                      >ลิงก์โหวตสำหรับผู้เข้าร่วม</span
                    >
                  </v-col>
                  <v-col cols="12" md="6" sm="6" xs="6">
                    <v-text-field outlined dense v-model="linkVote"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <!-- <v-row no-gutters class="mb-n2" v-if="false">
              <v-col cols="12" md="5" sm="12" xs="12" class="pt-2">
                <span style="font-size: 16px; color:red;">*</span><span style="font-size: 16px;">vender</span>
                </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-select
                  :items="venders"
                  dense
                  outlined
                  item-text="name"
                  item-value="name"
                  style="font-size: 10px;"
                  v-model="vender"
                  placeholder="กรุณาเลือก"
                  persistent-placeholder
                ></v-select>
              </v-col>
            </v-row> -->
              <v-row no-gutters v-if="this.userData.user.role != 'default'">
                <v-col cols="0" md="1" sm="1" sx="1"></v-col>
                <v-switch
                  v-model="secretroom"
                  inset
                  rounded
                  dense
                  color="#64DD17"
                ></v-switch>
                <span style="font-size: 16px; display: flex; align-items: center">{{
                  $t("roomsetting.secretmeeting")
                }}</span>
              </v-row>
              <!-- <div v-if="secretroom">
            <v-form ref="form">
              <v-row no-gutters class="mb-n2">
                <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                  <span style="font-size: 16px;">กรุณาระบุ LOA</span>
                </v-col>
                <v-col cols="12" md="6" sm="6" xs="6">
                  <v-select
                  :items="loa"
                  label="กรุณาเลือก LOA ผู้เข้าร่วมประชุม"
                  outlined
                  v-model="secelctloa"
                  dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </div> -->
              <v-row no-gutters class="mt-n5">
                <v-col cols="0" md="1" sm="1" sx="1"></v-col>
                <v-switch
                  v-model="stateLockRoom"
                  inset
                  rounded
                  dense
                  color="#64DD17"
                ></v-switch>
                <span style="font-size: 16px; display: flex; align-items: center">{{
                  $t("roomsetting.lock")
                }}</span>
              </v-row>
              <v-row no-gutters class="mt-n5">
                <v-col cols="0" md="1" sm="1" sx="1"></v-col>
                <v-switch
                  v-model="Allowguest"
                  inset
                  rounded
                  dense
                  color="#64DD17"
                ></v-switch>
                <span style="font-size: 16px; display: flex; align-items: center">{{
                  $t("roomsetting.anonymous")
                }}</span>
              </v-row>
            </div>
            <v-row class="pb-2">
              <v-col cols="1" md="1" sm="1" sx="1"></v-col>
              <v-col cols="12" md="10" sm="10" sx="10" class="mt-n3 mb-n4">
                <v-btn
                  text
                  class="no-uppercase p-0 m-0"
                  style="color: #3d85c6; font-size: 20px; text-decoration: underline"
                  @click="clickToShowOptionsmail"
                  >{{ $t("roomsetting.invitemail") }}</v-btn
                >
                <v-icon style="color: #3d85c6" @click="clickToShowOptionsmail">
                  mdi-chevron-down
                </v-icon>
              </v-col>
            </v-row>
            <div v-if="showOptionsmail">
              <v-row no-gutters class="mb-n2">
                <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                  <span style="font-size: 18px; font-weight: 500; color: #353535"
                    >{{ $t("roomsetting.subject") }} :</span
                  >
                  <!-- Mail subject -->
                </v-col>
                <v-col cols="12" md="6" sm="6" xs="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="subject"
                    style="font-size: 12px"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="1" md="1" sm="1" xs="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                  <span style="font-size: 18px; font-weight: 500; color: #353535"
                    >{{ $t("roomsetting.to") }} :</span
                  >
                  <!-- Send mail to -->
                </v-col>
                <v-col cols="12" md="6" sm="6" xs="6">
                  <v-combobox
                    :rules="emailRules"
                    v-model="email"
                    @keypress="keyroomemail"
                    label="Email : example.ex@inet.co.th"
                    multiple
                    outlined
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="accent white--text"
                          left
                          v-text="data.item.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item }}
                        <v-icon small @click="data.parent.selectItem(data.item)">
                          $delete
                        </v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                  <!-- <v-text-field
                  outlined
                  dense
                  v-model="email"
                  type="email"
                  placeholder="example.ex@gmail.com,example.ex@inet.co.th"
                ></v-text-field> -->
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions style="justify-content: center">
            <v-col cols="4" md="4" xs="4" sm="4">
              <v-btn block rounded color="error" @click="closeDialog"
                >{{ $t("button.btncancel") }}
              </v-btn>
            </v-col>
            <v-col cols="7" md="4" xs="4" sm="4">
              <v-btn
                block
                rounded
                style="color: white"
                color="#3D85C6"
                :disabled="!valid || !validpassword"
                @click="validate(valid)"
                >{{ $t("managepage.rooms") }}</v-btn
              >
            </v-col>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      onlyNumber: "this.value = this.value.replace(/[^0-9a-zA-Z!@#$%&*~+-฿/?]|/g, '')",
      valid: true,
      validpassword: true,
      jwt: require("jsonwebtoken"),
      showOptions: true,
      showOptionsmail: false,
      stateLockRoom: true,
      key: "",
      linkVote: "",
      // loa: ['LV.1', 'LV.2', 'LV.3', 'LV.4'],
      secelctloa: "",
      nameroom: "",
      subject: "",
      email: "",
      cid: "",
      profile: null,
      web: ["OneRTC"],
      type: "OneRTC",
      secretroom: false,
      Allowguest: true,
      user_id: "",
      txtLink: "",
      datamail: "",
      access_onechat: "",
      refresh_onechat: "",
      room_id_onechat: "",
      roomnamerules: [
        (v) => !!v || this.$t("loginpage.Pleasespecify"),
        (v) => /^[^ ]+/.test(v) || this.$t("loginpage.checkspace"),
      ],
      // emailRules: [
      //  v => /.+@.+/.test(v) || this.$t("loginpage.Invalidformat")
      // ],
      emailRules: [],
    };
  },
  created() {
    this.decodejwttoken();
    this.getuidrooms();
  },
  computed: {
    ...mapState("dialog", ["roomSetting"]),
    localDialog: {
      get() {
        return this.roomSetting;
      },
      set(value) {
        this.setDialogRoomSetting(value);
      },
    },
  },
  watch: {
    email: function (data) {
      if (data !== "") {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          const regex = /@/g;
          const myarr = data[index].match(regex);
          if (myarr === null || myarr === "") {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            data.forEach((e) => {
              if ((e = pattern.test(e))) {
                this.emailRules = [(v) => !!v || ""];
              } else {
                this.emailRules = [
                  (v) => pattern.test(v) || this.$t("loginpage.Invalidformat"),
                ];
              }
            });
          } else {
            const comma = element.split(",");
            if (comma.length > 1) {
              for (let index = 0; index < comma.length; index++) {
                const elementcomma = comma[index];
                const regex = /@/g;
                const myarrcomma = comma[index].match(regex);
                if (myarrcomma.length > 1) {
                  // console.log('myarrcommaif', myarrcomma)
                  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  data.forEach((e) => {
                    if ((e = pattern.test(e))) {
                      this.emailRules = [(v) => !!v || ""];
                      // console.log('pattern if')
                    } else {
                      // console.log('pattern else')
                      this.emailRules = [
                        (v) => pattern.test(v) || this.$t("loginpage.Invalidformat"),
                      ];
                    }
                  });
                }
              }
              this.emailRules = [];
            } else {
              // console.log('comma<=0', comma)
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              data.forEach((e) => {
                if ((e = pattern.test(e))) {
                  this.emailRules = [(v) => !!v || ""];
                } else {
                  this.emailRules = [
                    (v) => pattern.test(v) || this.$t("loginpage.Invalidformat"),
                  ];
                }
              });
            }
          }
        }
      } else if (data === "") {
        this.emailRules = [];
      }
    },
    Allowguest(value) {
      if (value) {
        this.secretroom = false;
        // this.login = true
      }
    },
    secretroom(value) {
      if (value) {
        this.Allowguest = false;
        // this.login = false
      }
    },
    // password() {
    //   this.has_minimum_lenth = this.password.length > 8
    //   this.has_number = /\d/.test(this.password)
    //   this.has_lowercase = /[a-z]/.test(this.password)
    //   this.has_uppercase = /[A-Z]/.test(this.password)
    //   this.has_special = /([!@#$%^&*+=._-])/.test(this.password)
    // },
  },
  methods: {
    ...mapActions("dialog", ["setDialogRoomSetting", "setDialogdataedit"]),
    goPage(link) {
      this.$router.push(link).catch(() => {});
    },
    filterInput(value) {
      // Custom rule to check for any character without "number or English"
      // const regex = /^[a-zA-Z0-9!@#$%^&*+=._-]+$/;
      // return regex.test(value) || this.$t("roomsetting.alertpass");
      if (value.length < 4 && value.length != 0) { 
        this.validpassword = false;
        return this.$t("roomsetting.alertpass");
      } else {
        this.validpassword = true;
        return true;
      }
    },
    userpassword(e) {
      // only english and number
      const key = e.which ? e.which : e.keyCode;
      if (key >= 33 && key <= 64) {
        return true;
      } // number
      if (key >= 65 && key <= 90) {
        return true;
      } // A-Z
      if (key >= 91 && key <= 125) {
        return true;
      } // a-z
      return e.preventDefault();
    },
    clickToShowOptions() {
      this.showOptions = !this.showOptions;
      // this.clickToAddPassword()
    },
    passwordkey(e) {
      const key = e.which ? e.which : e.keyCode;
      if (key === 32) {
        return e.preventDefault();
      }
    },
    validate(validate) {
      // console.log('validate', validate)
      // if(this.$refs.form.validate()) {
      if (validate === true) {
        this.checkloa();
      } else {
        this.$swal.fire({
            title: this.$t("loginpage.Invalidformat"),
            text: this.$t("loginpage.checkspace"),
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false
          })
      }
      // }
    },
    clickToShowOptionsmail() {
      this.showOptionsmail = !this.showOptionsmail;
    },
    clickToAddPassword() {
      this.key = this.randomPassword(2);
      // console.log('clickToAddPassword', this.key)
    },
    closeDialog() {
      this.setDialogRoomSetting(false);
      this.getuidrooms();
      this.nameroom = "";
      this.email = "";
      this.subject = "";
      this.key = "";
    },
    async refrestoken() {
      var token = localStorage.getItem("user-token");
      await this.axios
        .get(
          process.env.VUE_APP_API + "/api/lv1/auth/refreshtoken",
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("user-token"),
            },
          }
          // await this.axios.post(process.env.VUE_APP_API + '/api/v1/authentication/refrestoken', {
          //   headers: {
          //         Authorization: 'bearer ' + token
          //       }
          // }
        )
        .then((res) => {
          // console.log('sssss', res)
        })
        .catch((err) => {
          this.$swal.fire({
            title: this.$t("message.Sessiontimeout"),
            text: '',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false
          }).then((result) => {
            localStorage.clear();
            localStorage.setItem("lang", "th");
            window.open("/", "_self");
          });
        });
    },
    checkloa() {
      this.refrestoken();
      if (this.secretroom === true) {
        // this.secelctloa = 0
        // if (this.secelctloa === '') {
        //   this.secelctloa = 1
        // } else if (this.secelctloa === 'LV.1') {
        //   this.secelctloa = 1
        // } else if (this.secelctloa === 'LV.2') {
        //   this.secelctloa = 2
        // } else if (this.secelctloa === 'LV.3') {
        //   this.secelctloa = 3
        // } else if (this.secelctloa === 'LV.4') {
        //   this.secelctloa = 4
        // }
        this.createrooms();
        // this.createOnechat()
      } else if (this.secretroom === false) {
        this.secelctloa = "";
        this.createrooms();
        // this.createOnechat()
      }
      // this.createrooms()
      // this.createOnechat()
    },
    createOnechat() {
      this.room_id_onechat = Math.random();
      this.axios
        .post(
          process.env.VUE_APP_API_ONECHAT + "/backend/api/v1/rooms",
          {
            room_id: this.room_id_onechat.toString(),
            room_name: this.nameroom,
            user_id: this.userData.user.oneid,
            user_name: this.userData.user.name + " " + this.userData.user.lastname,
            user_profile: this.profile,
          },
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("access-token")}` },
          }
        )
        .then((result) => {
          const data = result.data.data;
          // console.log('createOneChat', data)
          this.access_onechat = data.access_token;
          this.refresh_onechat = data.refresh_token;
          this.createroomPexip();
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    createrooms() {
      if (this.nameroom === "") {
        this.$swal.fire({
            title: this.$t("loginpage.Pleasespecify") +
            this.$t("loginpage.name") +
            this.$t("table.roomsname"),
            text: '',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideCl
          });
      } else {
        if (this.showOptions === false) {
          this.key = "";
          this.secretroom = false;
          this.stateLockRoom = true;
          this.secelctloa = "";
          this.Allowguest = true;
        }
        if (this.type === "") {
          this.type = "OneRTC";
        }
        if (this.type === "OneRTC") {
          this.checkemail();
        } else {
          this.checkemail();
        }
      }
    },
    checkemail() {
      if (
        this.email === "" ||
        this.email.length === 0 ||
        this.email === null ||
        this.email === undefined
      ) {
        this.createroommeet();
      } else {
        for (let index = 0; index < this.email.length; index++) {
          const element = this.email[index];
          // console.log('element',element)
          const comma = element.split("@");
          const comma1 = element.split(".");
          // console.log('comma',comma)
          if (comma.length <= 1 || comma.length >= 3) {
            this.$swal.fire({
            title: this.$t("loginpage.email"),
            text: this.$t("loginpage.Invalidformat"),
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideCl
          });
            break;
          } else {
            this.createroommeet();
            break;
            // if(comma1.length <= 1 ||comma1.length >= 3){
            // this.$swal(this.$t("loginpage.email") , this.$t("loginpage.Invalidformat") , 'warning')
            // break
            // }else{
            //   this.createroommeet()
            // break
            // }
          }
        }
      }
    },
    createroommeet() {
      var data = {
        name: this.nameroom,
        key: this.key === null ? '' : this.key,
        secretroom: this.secretroom,
        login: this.Allowguest,
        // loa: this.secelctloa,
        meetingLock: this.stateLockRoom,
        type: this.type,
        email: this.email,
        subject: this.subject,
        uid: this.user_id,
        // vote: [this.linkVote],
        // onechat: {
        //   access_onechat: this.access_onechat,
        //   refresh_onechat: this.refresh_onechat,
        //   room_id: this.room_id_onechat.toString()
        // }
      };
      // console.log('data', data)
      this.axios
        .post(process.env.VUE_APP_API + "/api/lv1/room/settingroom", data)
        .then((res) => {
          // console.log('datatatat',res.data)
          if (res.data.result === "Success") {
            // localStorage.setItem('user-token', res.data.data)
            this.hostgetlobby(res.data.data);
            this.decodejwttoken();
            this.closeDialog();
          }
        })
        .catch((err) => {
          console.log("ERRORsettingroom: ", err.data.result);
        });
    },
    decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY);
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8));
        return decryptedData;
      } catch (error) {
        console.log(">>>>>>>>", error);
        return error;
      }
    },
    hostgetlobby(data) {
      // var token = data.token
      // const decryptedText = this.CryptoJS.AES.decrypt(
      //   token,
      //   process.env.VUE_APP_SECRET_KEY
      // )
      //   .toString(this.CryptoJS.enc.Utf8)
      //   .replace(/"/g, '')
      // var roomsetingdata = this.jwt.decode(decryptedText)
      // console.log('roomsetingdata', roomsetingdata)
      // this.userData = data
      this.$router.push({ name: "Lobby", params: { schedule: 1 } }).catch(() => {});
      // this.$router.push('/lobby')
      this.setDialogdataedit(data);
    },
    decodejwttoken() {
      var token = localStorage.getItem("user-token");
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      var data = this.jwt.decode(decryptedText);
      this.userData = data;
      // console.log('data.room', data)
      if (data.room !== null) {
        this.roomname = data.room.name;
        this.cid = process.env.VUE_APP_DOMAIN + "/join/?uuid=" + data.room.uid;
        this.txtLink = this.cid + "&openExternalBrowser=1";
        this.room = this.userData.room;
      } else {
        this.roomname = "";
        this.room = "";
        this.cid = "";
        this.txtLink = "";
      }
      // console.log('userData', this.userData)
      // this.refreshToken()
    },
    getuidrooms() {
      this.axios.get(process.env.VUE_APP_API + "/api/lv1/room/genuid").then((res) => {
        var datauid = JSON.parse(this.decodeJS(res.data.data));
        // console.log('getuidrooms', datauid.uid)
        this.user_id = datauid.uid;
        this.cid = process.env.VUE_APP_DOMAIN + "/join/?uuid=" + this.user_id;
        this.txtLink = this.cid + "&openExternalBrowser=1";
      });
    },
    getprofile() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/theme/get/" + this.user_id)
        .then((res) => {
          // console.log('res', res)
          // this.avatar = res.data.data.user.profile
          this.profile = res.data.data.user.profile;
          // console.log('user_profile', this.profile)
          this.createOnechat();
        })
        .catch((err) => {
          console.log("err getprofile", err);
        });
    },
    keyroomemail(e) {
      const key = e.which ? e.which : e.keyCode;
      if (key <= 32 || key >= 127) {
        return e.preventDefault();
      } else {
        return true;
      }
    },
    copylink() {
      var txtLink = document.getElementById("txtLink");
      txtLink.type = "text";
      txtLink.select();
      txtLink.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand("copy");
      txtLink.type = "hidden";
      this.$swal.fire({
            title: this.$t("loginpage.coppylink"),
            text: '',
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false
          })
    },
    randomPassword(length) {
      var chars = "abcdefghijklmnopqrstuvwxyz";
      var char = "QWERTYUIOPLKJHGFDSAZXCVBNM";
      var number = "1234567890";
      var characters = "!@#$%^&*+=._-";
      var pass = "";
      var pass1 = "";
      var pass2 = "";
      var pass3 = "";
      var pass4 = "";
      for (var x = 0; x < length; x++) {
        pass += chars.charAt(Math.floor(Math.random() * chars.length));
        pass1 += number.charAt(Math.floor(Math.random() * number.length));
        pass2 += char.charAt(Math.floor(Math.random() * char.length));
        pass3 += characters.charAt(Math.floor(Math.random() * characters.length));
        pass4 = pass + pass1 + pass2 + pass3;
      }
      return pass4;
    },
  },
};
</script>

<style scoped>
/* Overwrite the default to keep the scrollbar always visible */

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
